// extracted by mini-css-extract-plugin
export var addButton = "_e8-0";
export var border = "_e8-8";
export var check = "_e8-h";
export var danger = "_e8-6";
export var dropdownContainer = "_e8-1";
export var editModalBody = "_e8-j";
export var footerContainer = "_e8-i";
export var fullWidth = "_e8-a";
export var hide = "_e8-9";
export var icon = "_e8-3";
export var input = "_e8-7";
export var inputFlex = "_e8-b";
export var inputWrapper = "_e8-c";
export var manualFocus = "_e8-5";
export var optionButton = "_e8-4";
export var pillWrapper = "_e8-e";
export var pointer = "_e8-2";
export var showOverflow = "_e8-f";
export var tagsFlex = "_e8-d";
export var xButton = "_e8-g";